import { makeAutoObservable } from 'mobx'
import { type Integration } from 'entities/Integrations'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import { IntegrationCollapseSettingsStore } from 'pages/settings/pages/integrations/pages/integrationSettings/store/IntegrationCollapseSettingsStore'
import { IntegrationWebhookStore } from 'pages/settings/pages/integrations/store/IntegrationWebhookStore'
import { IntegrationCustomSettingsStore } from 'pages/settings/pages/integrations/pages/integrationSettings/store/IntegrationCustomSettingsStore'
import { KEAP_SYNC_CHECKBOX_KEYS } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationKeapSettings/lib'
import { IntegrationSettingsSyncStore } from 'pages/settings/pages/integrations/pages/integrationSettings/store/IntegrationSettingsSyncStore'
import { IntegrationSettingsPropertyStore } from 'pages/settings/pages/integrations/pages/integrationSettings/store/IntegrationSettingsPropertyStore'
import { type IKeapSettingsDict } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationKeapSettings/types'
import { IntegrationSettingsUsersStore } from 'pages/settings/pages/integrations/pages/integrationSettings/store/IntegrationSettingsUsersStore'
import { IntegrationTimelineStore } from 'pages/settings/pages/integrations/pages/integrationSettings/store/IntegrationTimelineStore'
import { type IIntegrationStore } from 'pages/settings/pages/integrations/pages/integrationSettings/hooks/useIntegrationStoreMemo'

export class IntegrationKeapSettingsStore implements IIntegrationStore {
  private _collapseStore
  private _webhookStore
  private _timelineStore
  private _customSettingsStore
  private _syncStore
  private _propertyStore
  private _userStore

  constructor(integration: Integration, private _entities: IEntitiesStore) {
    this._collapseStore = new IntegrationCollapseSettingsStore()
    this._webhookStore = new IntegrationWebhookStore(this._entities)
    this._timelineStore = new IntegrationTimelineStore(this._entities, 'infusionsoft')
    this._customSettingsStore = new IntegrationCustomSettingsStore<IKeapSettingsDict>(
      integration,
      this._entities
    )
    this._syncStore = new IntegrationSettingsSyncStore(
      integration,
      this._customSettingsStore,
      KEAP_SYNC_CHECKBOX_KEYS
    )
    this._propertyStore = new IntegrationSettingsPropertyStore(
      integration,
      this._customSettingsStore,
      this._entities
    )
    this._userStore = new IntegrationSettingsUsersStore(integration, this._entities)
    makeAutoObservable(this)
  }

  init = (integration: Integration) => {
    this._timelineStore.init()
    this._customSettingsStore.init1_0()
    this._syncStore.init()
    this._propertyStore.init()
    this._userStore.init()
    this._webhookStore.initIntegrationWebhookState(integration, true)
  }

  dispose = () => {
    this._syncStore.dispose()
    this._propertyStore.dispose()
    this._userStore.dispose()
    this._webhookStore.dispose()
  }

  get collapseStore() {
    return this._collapseStore
  }

  get webhookStore() {
    return this._webhookStore
  }

  get timelineStore() {
    return this._timelineStore
  }

  get propertyStore() {
    return this._propertyStore
  }

  get syncStore() {
    return this._syncStore
  }

  get userStore() {
    return this._userStore
  }
}
